const videos = [
    {
        title: 'The Bay Tour',
        url: 'https://www.youtube.com/watch?v=xhDQMUUZdio',
        description: 'A full loop of the bay area, starting in the South Bay and continuing counterclockwise over the 150 mile stretch.',
    },
    {
        title: "America's Most Beautiful Bike Ride",
        url: 'https://www.youtube.com/watch?v=O4eEIqxIGCs',
        description: "Footage from the 2024 America's Most Beautiful Bike Ride in Lake Tahoe. 80 miles of beautiful scenery and lake views.",
    },
    {
        title: 'Alpine Dam',
        url: 'https://www.youtube.com/watch?v=_z7g9PyfrK8',
        description: 'A relaxed group ride into Marin county to Alpine Dam. Lots of climbing from city to dam to the ridgeline.',
    },
    {
        title: 'China Camp',
        url: 'https://www.youtube.com/watch?v=6CkZZhwRLcQ',
        description: 'A return to gravel, in the form of a road ride from Berkeley to China Camp State Park, on the south side of the San Pablo Bay. Excellent miles, and great gravel trails, with pleasant weather to top it all off.',
    },
];

export default videos;
